/**
 * Checks if the supplied string is a UUID or a slug
 * @param slugOrId
 * @return true if the string is in UUIDv4 format
 */

export const isUUID = (slugOrId: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(slugOrId);
